import { Box, Chip, Typography } from "@mui/material";
import {
  CheckIcon,
  Eye,
  EyeIcon,
  PencilSimple,
  PencilSimpleIcon,
  TrashSimple,
  TrashSimpleIcon,
  XIcon,
} from "@phosphor-icons/react";
import { StyledInvoiceListItem } from "./invoiceListItem.styled";
import { Invoice } from "../../../models/Invoice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useInvoice } from "../../../stores/useInvoice";
import { useProfile } from "../../../stores/useProfile";
import { formatDateToDDMMYYYY } from "../../../globals/utils";

type InvoiceListItemProps = {
  invoice: Invoice;
  fullScreen: boolean;
  onSelect: (invoice: Invoice) => void;
  onRemove?: () => void;
};

export const InvoiceListItem = ({
  invoice,
  fullScreen,
  onSelect,
  onRemove
}: InvoiceListItemProps) => {
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const navigate = useNavigate();
  const {removeInvoice} = useInvoice();
  const {user} = useProfile();

  const handleRemove = async () => {
    if (!user || !invoice.id) return;
    const res = await removeInvoice(user, invoice.id);

    if (res === 200 && onRemove) {
      setConfirmation(false)
      onRemove();
    }
  }

  return (
    <StyledInvoiceListItem
      type={invoice.type}
      fullScreen={fullScreen}
      hasBeenPayed={invoice.hasBeenPayed}>
      <Typography variant="h5" className="date">
        {formatDateToDDMMYYYY(new Date(invoice.invoiceDate))}
      </Typography>
      {fullScreen && (
        <Typography variant="h5" className="date">
          {invoice.paymentDate
            ? formatDateToDDMMYYYY(new Date(invoice.paymentDate))
            : "--/--/----"}
        </Typography>
      )}
      {fullScreen && (
        <Typography variant="h5" className="ref">
          {invoice.structuredReference ?? ""}
        </Typography>
      )}
      <Typography variant="h5" className="name">
        {invoice.name}
      </Typography>
      {fullScreen && (
        <>
          <Typography variant="h5" className="description">
            {invoice.description}
          </Typography>
          <Chip label={invoice.type} className="type" />
          <Typography variant="h5" className="value">
            &#8364; {Number(invoice.priceExVat).toFixed(2)}
          </Typography>
          <Typography variant="h5" className="value">
            &#8364; {Number(invoice.vat).toFixed(2)}
          </Typography>
        </>
      )}

      <Typography variant="h5" className="value">
        &#8364; {(Number(invoice.priceExVat) + Number(invoice.vat)).toFixed(2)}
      </Typography>
      {fullScreen && (
        <Typography variant="h5" className="yearQuarter">
          {invoice.quarter}
        </Typography>
      )}
      {fullScreen && (
        <Box className="buttonWrapper">
          <EyeIcon
            size={24}
            className="button"
            weight="bold"
            onClick={() => navigate(`/invoice/${invoice.id}`)}
          />
          {!confirmation && (
            <PencilSimpleIcon
              size={24}
              className="button"
              weight="bold"
              onClick={() => onSelect(invoice)}
            />
          )}

          {confirmation ? (
            <>
              <CheckIcon size={24} className="button" weight="bold" onClick={handleRemove}/>
              <XIcon
                size={24}
                className="button"
                weight="bold"
                onClick={() => setConfirmation(false)}
              />
            </>
          ) : (
            <TrashSimpleIcon
              size={24}
              className="button"
              weight="bold"
              onClick={() => setConfirmation(true)}
            />
          )}
        </Box>
      )}
    </StyledInvoiceListItem>
  );
};
